/* Copies each item's "Print placement" choice into the order note, so production (Lineworks) sees it on the order. */
(function(){
  var START='>>> PRINT SETUP (production) >>>', END='<<< END PRINT SETUP <<<', busy=false, orig=window.fetch;
  function block(cart){
    var lines=(cart.items||[]).filter(function(i){return i.properties&&i.properties['Print placement']}).map(function(i){
      return '- '+i.product_title+' ('+(i.variant_title||'')+') x'+i.quantity+': '+String(i.properties['Print placement']).toUpperCase();
    });
    return lines.length?START+'\n'+lines.join('\n')+'\n'+END:'';
  }
  function strip(note){
    var a=note.indexOf(START), b=note.indexOf(END);
    if(a>-1&&b>a) note=note.slice(0,a)+note.slice(b+END.length);
    return note.trim();
  }
  function sync(){
    if(busy) return; busy=true;
    return orig.call(window,'/cart.js').then(function(r){return r.json()}).then(function(cart){
      var note=cart.note||'', clean=strip(note), blk=block(cart);
      var next=(blk+(blk&&clean?'\n\n':'')+clean).trim();
      if(next===note.trim()) return;
      return orig.call(window,'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','X-PK':'1'},body:JSON.stringify({note:next})});
    }).catch(function(){}).then(function(){busy=false});
  }
  window.pkSyncNote=sync;
  window.fetch=function(u,o){
    var p=orig.apply(this,arguments), url=typeof u==='string'?u:(u&&u.url)||'';
    var own=o&&o.headers&&(o.headers['X-PK']||(o.headers.get&&o.headers.get('X-PK')));
    if(!own&&/\/cart\/(add|change|update|clear)/.test(url)) p.then(function(){setTimeout(sync,200)}).catch(function(){});
    return p;
  };
  if(/^\/cart/.test(location.pathname)) document.addEventListener('DOMContentLoaded',sync);
})();
